import { useSSOCallback } from 'features/sso/hooks/useSSOCallback';
import { useEnableFlightTrackerLayer } from 'features/mapping/hooks/useEnableFlightTrackerLayer';
import { useQueryParams } from 'hooks/useQueryParams';
import { enqueueSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { registerDeviceWithWatchDuty } from 'shared/device';
import { useAuthState } from 'state/useAuthState';
import * as Sentry from '@sentry/capacitor';
import { History } from 'history';
import { Loader } from 'components/Loader';

const handleLoginError = (
  history: History,
  errorMessage: string,
  params: Record<string, string | null>,
): void => {
  const { code, ...extra } = params;
  Sentry.captureMessage('SSO login failed', {
    level: 'warning',
    extra: {
      ...extra,
    },
  });
  enqueueSnackbar(errorMessage, { variant: 'error' });
  history.replace('/login');
};

export const SSOCallback = (): JSX.Element | null => {
  const history = useHistory();
  const { loginSuccess } = useAuthState();
  const { enableFlightTrackerLayerForMember } = useEnableFlightTrackerLayer();
  const [params] = useQueryParams();

  useSSOCallback({
    params,
    onSuccess: (data) => {
      loginSuccess(data.key, data.user);
      enableFlightTrackerLayerForMember(data.user);
      registerDeviceWithWatchDuty({ user: data.user });
      history.replace(`/`);
    },
    onError: (message: string) => {
      handleLoginError(history, message, params);
    },
  });

  return <Loader disableBackground />;
};
